import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { appInsightsConfig } from './AppInsightsConfig';

const appInsights = new ApplicationInsights({ config: appInsightsConfig });
appInsights.loadAppInsights();
export default appInsights;
